<template>
  <a-table :columns="columns" :data-source="data" :pagination="false">

    <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
      {{ record.description }}
    </p>
  </a-table>
</template>
<script>
  const columns = [
    { title: '后台更新公告', dataIndex: 'msg', key: 'msg' },
  ];

  const data = [
    {
      key: 1,
      msg: '2023-07-12更新优化内容',
      description: '活动申请记录添加新功能-如收到新申请订单需有声音提示',
    },
    {
      key: 2,
      msg: '2023-08-17更新优化内容',
      description: '新增优惠活动中添加上传图片/上传影片之功能',
    },
    {
      key: 3,
      msg: '2025-11-04更新优化内容',
      description: '◆新增联动现金后台的存款，判断未存款会员，取消当期俸禄\n◆新增电子、真人排行榜联动现金后台的有效投注\n◆活动优惠大厅添加限制次数',
    },
    {
      key: 4,
      msg: '2026-01-20更新优化内容',
      description: '◆新增USDT排行榜联动现金后台的存款',
    }
  ];

  export default {
    data() {
      return {
        data,
        columns,
      };
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/default.vue